module.exports = __webpack_public_path__ + "img/test.98104a0a.png";